module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.account.companyId),
      callback: function($$v) {
        _vm.$set(_vm.account, "companyId", $$v)
      },
      expression: "account.companyId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.holder,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingHolder)); }]
    },
    model: {
      value: (_vm.account.name),
      callback: function($$v) {
        _vm.$set(_vm.account, "name", $$v)
      },
      expression: "account.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.username,
      "hint": _vm.$lang.labels.lowerCase,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingUserName)); }]
    },
    on: {
      "blur": function($event) {
        _vm.account.userName = _vm.account.userName.toLowerCase().trim()
      }
    },
    model: {
      value: (_vm.account.userName),
      callback: function($$v) {
        _vm.$set(_vm.account, "userName", $$v)
      },
      expression: "account.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.email,
      "type": "email"
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  })], 1), _vm._v(" "), (_vm.lastLoggedInOn) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.lastLoggedinOn,
      "readonly": ""
    },
    model: {
      value: (_vm.lastLoggedInOn),
      callback: function($$v) {
        _vm.lastLoggedInOn = $$v
      },
      expression: "lastLoggedInOn"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.maxDiscount,
      "type": "number",
      "min": "0",
      "step": "0.05",
      "required": "",
      "rules": [function (v) { return _vm.checkMaxDiscountPercentage(v) || ("" + (_vm.$lang.errors.missingDicount)); }]
    },
    model: {
      value: (_vm.account.maxDiscountPercentage),
      callback: function($$v) {
        _vm.$set(_vm.account, "maxDiscountPercentage", $$v)
      },
      expression: "account.maxDiscountPercentage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.mappedPrinters,
      "label": _vm.$lang.actions.selectDefaultPrinter,
      "required": "",
      "disabled": _vm.mappedPrinters.lenght === 0,
      "loading": _vm.printersLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingDefaultPrinter)); }]
    },
    model: {
      value: (_vm.account.defaultPrinter),
      callback: function($$v) {
        _vm.$set(_vm.account, "defaultPrinter", $$v)
      },
      expression: "account.defaultPrinter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "mb-3": ""
    }
  }, [_c('p', {
    staticClass: "pl-2 mb-0 pb-0"
  }, [_vm._v(_vm._s(_vm.$lang.header.roleManagement) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex"
  }, [_c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        return _vm.manageRoles('none')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.none) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        return _vm.manageRoles('user')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.atUser) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        return _vm.manageRoles('admin')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.atLocalAdmin) + "\n          ")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "small-chips": "",
      "deletable-chips": "",
      "multiple": "",
      "label": _vm.$lang.actions.selectRoles,
      "loading": _vm.rolesLoading,
      "items": _vm.sortedRoles
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.apiKey
    },
    model: {
      value: (_vm.account.apiKey),
      callback: function($$v) {
        _vm.$set(_vm.account, "apiKey", $$v)
      },
      expression: "account.apiKey"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.nfcToken
    },
    model: {
      value: (_vm.account.nfcToken),
      callback: function($$v) {
        _vm.$set(_vm.account, "nfcToken", $$v)
      },
      expression: "account.nfcToken"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.notes,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.account.notes),
      callback: function($$v) {
        _vm.$set(_vm.account, "notes", $$v)
      },
      expression: "account.notes"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'accounts'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary mx-2",
    attrs: {
      "disabled": _vm.passSnackbar || _vm.account.accountStatus === 'inactive'
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.resetPassword) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid || _vm.isPrinterActive || _vm.impactSnackbar
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "snackbar-wrap"
  }, [_c('v-snackbar', {
    staticClass: "mx-3",
    attrs: {
      "bottom": "",
      "timeout": _vm.timeout,
      "color": "success",
      "multi-line": ""
    },
    model: {
      value: (_vm.passSnackbar),
      callback: function($$v) {
        _vm.passSnackbar = $$v
      },
      expression: "passSnackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.labels.yourPassword) + _vm._s(_vm.password) + "\n      "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.passSnackbar = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")])], 1), _vm._v(" "), _c('v-snackbar', {
    staticClass: "mx-3",
    attrs: {
      "bottom": "",
      "timeout": _vm.timeout,
      "color": "error",
      "multi-line": ""
    },
    model: {
      value: (_vm.impactSnackbar),
      callback: function($$v) {
        _vm.impactSnackbar = $$v
      },
      expression: "impactSnackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.labels.accountImpactWarning) + "\n      "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.impactSnackbar = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b527d9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/AccountDetails.vue
// module id = 401
// module chunks = 35